export const PANEL_LOADING_HEIGHT = '200px';
